import {
  Card,
  Group,
  NumberInput,
  Text,
  TextInput,
  UnstyledButton,
} from '@mantine/core';
import { useEmployeeFormContext } from '../EmployeeEducationSection';
import { IconPlus } from '@tabler/icons-react';
import { TbTrashXFilled } from 'react-icons/tb';
import { DateInput, type DateValue } from '@mantine/dates';
import dayjs from 'dayjs';
import { dateFormat } from '@/index';

const EmployeeCoursesCard: React.FC = () => {
  const form = useEmployeeFormContext();

  const handleCreateCourse = (): void => {
    const newCourse = {
      name: '',
      date: dayjs(new Date()).format(dateFormat),
      hours: 1,
    };

    form.insertListItem('courses', newCourse);
  };

  const handleDeleteCourse = (index: number): void => {
    form.removeListItem('courses', index);
  };

  const courseRows = form.values.courses.map((course, index) => (
    <tr key={index}>
      <td style={{ width: '50%' }} className="pr-3 pt-3">
        <TextInput
          variant="filled"
          radius="md"
          placeholder="Název kurzu"
          {...form.getInputProps(`courses.${index}.name`)}
        />
      </td>
      <td style={{ width: '25%' }} className="pr-3 pt-3">
        <DateInput
          variant="filled"
          radius="md"
          placeholder="datum"
          valueFormat={dateFormat}
          value={dayjs(course.date, dateFormat).toDate()}
          onChange={(d: DateValue) => {
            const date: string = dayjs(d).format(dateFormat);
            form.setFieldValue(`courses.${index}.date`, date);
          }}
          error={form.getInputProps(`courses.${index}.date`).error}
          locale="cs"
        />
      </td>
      <td className="pr-3 pt-3">
        <NumberInput
          variant="filled"
          radius="md"
          placeholder="počet hodin"
          min={1}
          {...form.getInputProps(`courses.${index}.hours`)}
        />
      </td>
      <td className="pt-3">
        <UnstyledButton
          data-testid="delete course"
          onClick={() => handleDeleteCourse(index)}
        >
          <TbTrashXFilled size="30" />
        </UnstyledButton>
      </td>
    </tr>
  ));

  return (
    <Card padding="md" radius="md" withBorder className="h-full">
      <Group justify="space-between">
        <Text fw={700} size="large">
          Kurzy a školící akce
        </Text>
        <UnstyledButton data-testid="add course" onClick={handleCreateCourse}>
          <IconPlus />
        </UnstyledButton>
      </Group>

      <table className="mt-3">
        <thead>
          <tr>
            <th className="text-left">Název kurzu</th>
            <th className="text-left">Datum</th>
            <th className="text-left">Hodiny</th>
            <th></th>
          </tr>
        </thead>
        <tbody>{courseRows}</tbody>
      </table>
    </Card>
  );
};

export default EmployeeCoursesCard;
